var CoreTooltipPlacement = /*#__PURE__*/function (CoreTooltipPlacement) {
  CoreTooltipPlacement["AUTOSTART"] = "auto-start";
  CoreTooltipPlacement["AUTO"] = "auto";
  CoreTooltipPlacement["AUTOEND"] = "auto-end";
  CoreTooltipPlacement["TOPSTART"] = "top-start";
  CoreTooltipPlacement["TOP"] = "top";
  CoreTooltipPlacement["TOPEND"] = "top-end";
  CoreTooltipPlacement["RIGHTSTART"] = "right-start";
  CoreTooltipPlacement["RIGHT"] = "right";
  CoreTooltipPlacement["RIGHTEND"] = "right-end";
  CoreTooltipPlacement["BOTTOMSTART"] = "bottom-start";
  CoreTooltipPlacement["BOTTOM"] = "bottom";
  CoreTooltipPlacement["BOTTOMEND"] = "bottom-end";
  CoreTooltipPlacement["LEFTSTART"] = "left-start";
  CoreTooltipPlacement["LEFT"] = "left";
  CoreTooltipPlacement["LEFTEND"] = "left-end";
  return CoreTooltipPlacement;
}({});
export { CoreTooltipPlacement };